module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "content content-padding"
  }, [_c('div', {
    staticClass: "title-with-selector h1-selector"
  }, [_c('h1', [_vm._v(_vm._s(_vm.coach ? _vm.coach.languages[0].pivot.name : null))]), _vm._v(" "), _c('state-selector', {
    attrs: {
      "selected": _vm.coach ? parseInt(_vm.coach.state_id) : null,
      "target": _vm.coach,
      "update": 'coach'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('span', [_c('b', [_vm._v("Nome [PT]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('pt')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('span', [_c('b', [_vm._v("Nome [EN]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('en')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('span', [_c('b', [_vm._v("Nome [ES]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('es')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('span', [_c('b', [_vm._v("Nome [FR]")]), _c('br'), _vm._v(_vm._s(_vm.getCoachNameByLanguage('fr')))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('background_color')) + "\n            "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.getCoachProperty('background_color')
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor de Titulo + Texto do Menu")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('title_color')) + "\n            "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.getCoachProperty('title_color')
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor Botões Inactivos")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('inactive_color')) + "\n            "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.getCoachProperty('inactive_color')
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor Botões Activos")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('active_color')) + "\n            "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.getCoachProperty('active_color')
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor de Separadores do Menu")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n            " + _vm._s(_vm.getCoachProperty('filet_color')) + "\n            "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.getCoachProperty('filet_color')
    })
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(_vm.coach && _vm.coach.background_path) ? _c('div', {
    staticClass: "column is-half"
  }, [_vm._m(0), _vm._v(" "), _c('figure', {
    staticClass: "image is-16by9 coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.coachBackground
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.coach && _vm.coach.foreground_path) ? _c('div', {
    staticClass: "column is-half"
  }, [_vm._m(1), _vm._v(" "), _c('figure', {
    staticClass: "image is-16by9 coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.coachForeground
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openEditCoachModal
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Editar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Background")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Foreground")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0afe4b19!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachInfo.vue
// module id = 303
// module chunks = 1